import {TeamAPI} from "@brg/api";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {OrganizationsActions, OrganizationsSelector} from "../../reducers/OrganizationsSlice";

export const useGetOrganizationEntity = (teamId: string) => {

    const organization = useSelector(OrganizationsSelector);
    const dispatch = useDispatch();

        useEffect(() => {
        if (!teamId || organization.teamId === teamId) return;
          dispatch(OrganizationsActions.setOrganization({
            teamId: '',
            tagIds: [],
            contextName: '',
            avatar: [],
            managedTagIds: [],
            ownersIDs: []
          }));
        TeamAPI.Get({ idTeam: teamId })
            .then((r: any) => r.json())
            .then(r => {
                if (!r) return;

                const newTeam = r;

                if (!newTeam) return;

                dispatch(OrganizationsActions.setOrganization({
                    teamId: newTeam?.teamId || '',
                    tagIds: newTeam?.tagIds || [],
                    managedTagIds: newTeam?.managedTagIds || [],
                    contextName: newTeam?.contextName || '',
                    avatar: newTeam.avatar || [],
                    ownersIDs: newTeam?.ownersIDs
                }))

            }).catch(err => {
                console.error(err)
        })
    }, [teamId])

    return organization;
}import {TeamAPI} from "@brg/api";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {OrganizationsActions, OrganizationsSelector} from "../../reducers/OrganizationsSlice";

export const useGetOrganizationEntity = (teamId: string) => {

    const organization = useSelector(OrganizationsSelector);
    const dispatch = useDispatch();

        useEffect(() => {
        if (!teamId || organization.teamId === teamId) return;
          dispatch(OrganizationsActions.setOrganization({
            teamId: '',
            tagIds: [],
            contextName: '',
            avatar: [],
            managedTagIds: [],
            ownersIDs: []
          }));
        TeamAPI.Get({ idTeam: teamId })
            .then((r: any) => r.json())
            .then(r => {
                if (!r) return;

                const newTeam = r;

                if (!newTeam) return;

                dispatch(OrganizationsActions.setOrganization({
                    teamId: newTeam?.teamId || '',
                    tagIds: newTeam?.tagIds || [],
                    managedTagIds: newTeam?.managedTagIds || [],
                    contextName: newTeam?.contextName || '',
                    avatar: newTeam.avatar || [],
                    ownersIDs: newTeam?.ownersIDs
                }))

            }).catch(err => {
                console.error(err)
        })
    }, [teamId])

    return organization;
}